module.exports = __webpack_public_path__ + "img/1.0cb14c44.png";